import React, { useEffect, useRef } from 'react';
import { flipGridVisualHorizontally, flipGridVisualVertically, rotatePuzzleVisual } from '../megarubigramUtils';
import ControlGrid from './ControlGrid';
import { MegarubigramStore } from '../MegarubigramStore';
import { IconButton } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SolvedOuterControlGrid from './solved/SolvedOuterControlGrid';
import { useSolvedOnLoad } from '../../shared/utils';

const OuterControlGrid = () => {
  const { degreesRotated, revealed, solved } = MegarubigramStore.useState();

  const wasSolvedOnLoad = useSolvedOnLoad(solved);

  const puzzleIsRotated90Deg = degreesRotated % 180 !== 0;
  const gridStyles: React.CSSProperties = {
    transform: `rotate(${degreesRotated}deg)`
    // always rotate on vertical axis for solved animation
    + (solved ? (puzzleIsRotated90Deg ? ` rotateX(360deg)`: ` rotateY(360deg)`): ''),
  };

  // why +50? i have no idea. somehow somewhere it's being rotated -50º
  // when compared to the other rotate button icons. idk and idc rn.
  const centerButtonStyles: React.CSSProperties = {
    transform: `rotate(${-1*(degreesRotated+50)}deg) scaleX(-1)`,
  };

  if (revealed || wasSolvedOnLoad) return <SolvedOuterControlGrid/>;

  return (
    <div className="outerGridContainer" onContextMenu={(e) => { e.preventDefault(); }}>
      {/* Goes 0,1,3,2 because that puts it visually in clockwise order
      (0123 starting from upper left) for the sake of the math that
      determines which grid is in which corner when the puzzle is rotated. 
      (getGridIdAccountingForPuzzleRotation) */}
      <div className="puzzleRotationContainer" style={gridStyles}>
        <ControlGrid gridId={0}/>

        <ControlGrid gridId={1}/>

        <ControlGrid gridId={3}/>

        <ControlGrid gridId={2}/>

        <IconButton disableRipple className="rotateGridClockwiseButton" title="Rotate Clockwise/Counterclockwise"
          onClick={() => rotatePuzzleVisual(true)}
          onContextMenu={(e) => {
            e.preventDefault();
            rotatePuzzleVisual(false);
          }}
        >
          <ReplayIcon style={centerButtonStyles}/>
        </IconButton>

        <IconButton disableRipple className="flipVerticallyButton upperLeft" title="Flip" onClick={() => flipGridVisualVertically(0)}>
          <SwapVertIcon/>
        </IconButton>
        <IconButton disableRipple className="flipHorizontallyButton upperLeft" title="Flip" onClick={() => flipGridVisualHorizontally(0)}>
          <SwapHorizIcon/>
        </IconButton>

        <IconButton disableRipple className="flipVerticallyButton upperRight" title="Flip" onClick={() => flipGridVisualVertically(1)}>
          <SwapVertIcon/>
        </IconButton>
        <IconButton disableRipple className="flipHorizontallyButton upperRight" title="Flip" onClick={() => flipGridVisualHorizontally(1)}>
          <SwapHorizIcon/>
        </IconButton>

        <IconButton disableRipple className="flipVerticallyButton lowerLeft" title="Flip" onClick={() => flipGridVisualVertically(3)}>
          <SwapVertIcon/>
        </IconButton>
        <IconButton disableRipple className="flipHorizontallyButton lowerLeft" title="Flip" onClick={() => flipGridVisualHorizontally(3)}>
          <SwapHorizIcon/>
        </IconButton>

        <IconButton disableRipple className="flipVerticallyButton lowerRight" title="Flip" onClick={() => flipGridVisualVertically(2)}>
          <SwapVertIcon/>
        </IconButton>
        <IconButton disableRipple className="flipHorizontallyButton lowerRight" title="Flip" onClick={() => flipGridVisualHorizontally(2)}>
          <SwapHorizIcon/>
        </IconButton>
      </div>
    </div>
  );
};

export default OuterControlGrid;